import React, { Component } from "react";
import Results from "../../components/results/Results";
import PouleResultsDialog from "../../components/results/PouleResultsDialog";
import PhaseResultsDialog from "../../components/results/PhaseResultsDialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import { groupBy } from "../../util/GroupBy";
import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import moment from "moment-timezone";
import FasesContainer from "./FasesContainer";
import ExportContainer from "./ExportContainer";
import NoResultsMessage from "../../components/results/NoResultsMessage";
import FinishedDialog from "../../components/FinishedDialog";
import RankingContainer from "./RankingContainer";
import DaysContainer from "../schedule/DaysContainer";
// import Button from "@material-ui/core/Button";
import { languages } from "../../constants/languages";
import { getMatchDuration } from "../../util/GetMatchDuration";
import defaultFases from "../../constants/DefaultFases";
import Typography from "@material-ui/core/Typography";

class ResultsContainer extends Component {
  state = {
    teams: [],
    teamsByKey: {},
    teamsLoaded: false,
    matches: [],
    matchesByKey: {},
    matchesLoaded: false,
    poules: [],
    poulesByKey: {},
    poulesLoaded: false,
    brackets: [],
    subBrackets: {},
    bracketsByKey: {},
    bracketsLoaded: false,
    resultSpotsAll: [],
    resultSpotsLoaded: false,
    refereesByKey: {},
    refereesLoaded: false,
    oneSecondPassed: false,
    value: 0,
    finishedDialogOpen: false,
    selectedDay: "0",
    days: [],
    daysByKey: {},
    daysLoaded: false,
    selectedSportPark: "0",
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    players: [],
    playersByKey: {},
    playersLoaded: false,
    daysWithOpenMatches: [],
    manualDaySelected: false,
    selectedPoule: null,
    selectedPhase: null,
    selectedDivision: null,
  };

  selectDay = (dayId) => {
    this.setState({ selectedDay: dayId, manualDaySelected: true });
  };

  selectSportPark = (sportParkId) => {
    this.setState({ selectedSportPark: sportParkId });
  };

  selectPoule = (pouleId) => {
    this.setState({ selectedPoule: pouleId });
  };

  selectPhase = (phaseId, divisionId) => {
    this.setState({ selectedPhase: phaseId, selectedDivision: divisionId });
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  UNSAFE_componentWillMount = () => {
    this.timeout = setTimeout(() => {
      this.setState({ oneSecondPassed: true });
    }, 500);
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribeTeams = tournamentRef
      .collection("teams")
      .onSnapshot((querySnapshot) => {
        let teams = [];
        let teamsByKey = {};
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          teams.push(team);
          teamsByKey[doc.id] = team;
        });
        this.setState({
          teams: teams,
          teamsByKey: teamsByKey,
          teamsLoaded: true,
        });
      });

    this.unsubscribePlayers = tournamentRef
      .collection("players")
      .onSnapshot((querySnapshot) => {
        let players = [];
        let playersByKey = {};
        querySnapshot.forEach((doc) => {
          let player = doc.data();
          player["id"] = doc.id;
          players.push(player);
          playersByKey[doc.id] = player;
        });
        this.setState({
          players: players,
          playersByKey: playersByKey,
          playersLoaded: true,
        });
      });

    this.unsubscribeMatches = tournamentRef
      .collection("matches")
      .onSnapshot((querySnapshot) => {
        let matches = [];
        let matchesByKey = {};
        let daysWithOpenMatches = [];
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          if (match.day === undefined) {
            match["day"] = "0";
          }
          match["id"] = doc.id;
          matches.push(match);
          matchesByKey[doc.id] = match;
          if ((match.score1 === null || match.score2 === null) && match.field) {
            if (daysWithOpenMatches.indexOf(match.day) === -1) {
              daysWithOpenMatches.push(match.day);
            }
          }
        });

        this.setState({
          matches: matches,
          matchesByKey: matchesByKey,
          matchesLoaded: true,
          daysWithOpenMatches: daysWithOpenMatches,
        });
      });

    this.unsubscribePoules = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules")
      .onSnapshot((querySnapshot) => {
        let poules = [];
        let poulesByKey = {};
        querySnapshot.forEach((doc) => {
          let poule = doc.data();
          poule["id"] = doc.id;
          poules.push(poule);
          poulesByKey[doc.id] = poule;
        });
        this.setState({
          poules: poules,
          poulesByKey: poulesByKey,
          poulesLoaded: true,
        });
      });

    this.unsubscribeBrackets = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets")
      .onSnapshot((querySnapshot) => {
        let brackets = [];
        let subBrackets = {};
        let bracketsByKey = {};
        querySnapshot.forEach((doc) => {
          let bracket = doc.data();
          bracket["id"] = doc.id;
          bracket["isBracket"] = true;
          if (bracket.subBracketTo) {
            if (subBrackets[bracket.subBracketTo] === undefined) {
              subBrackets[bracket.subBracketTo] = [];
            }
            subBrackets[bracket.subBracketTo].push(bracket);
          }
          brackets.push(bracket);
          bracketsByKey[doc.id] = bracket;
        });
        this.setState({
          brackets: brackets,
          subBrackets: subBrackets,
          bracketsByKey: bracketsByKey,
          bracketsLoaded: true,
        });
      });

    this.unsubscribeResultSpots = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots")
      .onSnapshot((querySnapshot) => {
        let resultSpotsAll = [];
        querySnapshot.forEach((doc) => {
          let resultSpot = doc.data();
          resultSpot["id"] = doc.id;
          resultSpot["resultSpot"] = true;
          resultSpotsAll.push(resultSpot);
        });
        this.setState({
          resultSpotsAll: resultSpotsAll,
          resultSpotsLoaded: true,
        });
      });

    this.unsubscribeReferees = tournamentRef
      .collection("referees")
      .onSnapshot((querySnapshot) => {
        let referees = [];
        let refereesByKey = {};
        querySnapshot.forEach(function (doc) {
          let referee = doc.data();
          referee["id"] = doc.id;
          referees.push(referee);
          refereesByKey[doc.id] = referee;
        });

        this.setState({
          referees: referees,
          refereesByKey: refereesByKey,
          refereesLoaded: true,
        });
      });

    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });

    this.unsubscribeSportparks = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        let sportParksObj = {};
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
          sportParksObj[doc.id] = sportPark;
        });
        let sportParksSorted = sportParks.sort((a, b) => {
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          } else if (a.id < b.id) {
            return -1;
          } else {
            return 0;
          }
        });
        let newState = {
          sportParks: sportParksSorted,
          sportParksByKey: sportParksObj,
          sportParksLoaded: true,
        };
        if (!this.state.sportParksLoaded) {
          newState["selectedSportPark"] = (sportParksSorted[0] || {}).id || "0";
        }
        this.setState(newState);
      });
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
    this.unsubscribeTeams();
    this.unsubscribeMatches();
    this.unsubscribePoules();
    this.unsubscribeBrackets();
    this.unsubscribeResultSpots();
    this.unsubscribeReferees();
    this.unsubscribeDays();
    this.unsubscribeSportparks();
    this.unsubscribePlayers();
  };

  render() {
    let toRender = (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          paddingTop: 20,
          height: 177,
        }}
      >
        {this.state.oneSecondPassed && <CircularProgress />}
      </div>
    );
    if (
      this.state.teamsLoaded &&
      this.state.matchesLoaded &&
      this.state.poulesLoaded &&
      this.state.bracketsLoaded &&
      this.state.resultSpotsLoaded &&
      this.state.refereesLoaded &&
      this.state.daysLoaded &&
      this.state.playersLoaded
    ) {
      let initialDay = "0";
      if (!this.state.manualDaySelected) {
        if (this.state.daysWithOpenMatches.indexOf("0") === -1) {
          for (let i in this.state.days) {
            let d = this.state.days[i];
            if (this.state.daysWithOpenMatches.indexOf(d.id) !== -1) {
              initialDay = d.id;
              break;
            }
          }
        }
      }
      let showReferees = false;
      let showReferees2 = false;
      let showReferees3 = false;
      let showReferees4 = false;
      let showReferees5 = false;
      // get the time for matches
      let matches = [];
      for (let m in this.state.matches) {
        const match = this.state.matches[m];

        if (match.referee) {
          showReferees = true;
        }
        if (match.referee2) {
          showReferees2 = true;
        }
        if (match.referee3) {
          showReferees3 = true;
        }
        if (match.referee4) {
          showReferees4 = true;
        }
        if (match.referee5) {
          showReferees5 = true;
        }

        const poule = this.state.poulesByKey[match.poule];
        if (poule !== undefined) {
          if (poule.losersFinal) {
            const bracket = this.state.bracketsByKey[poule.bracket] || {};
            if (bracket.showLosersFinal) {
              matches.push(match);
            }
          } else {
            matches.push(match);
          }
        }
      }
      let breaks = Object.keys(this.props.tournament.breaks || {}).map(
        (key, i) => {
          let tournamentBreak = this.props.tournament.breaks[key];
          tournamentBreak["id"] = key;
          tournamentBreak["isBreak"] = true;
          return tournamentBreak;
        }
      );
      if (!this.props.tournament.online) {
        matches = matches.concat(breaks);
      }
      // matches per day
      let matchesPerDay = groupBy(matches, "day");
      for (let d in matchesPerDay) {
        let matchesForDay = matchesPerDay[d];
        let matchesPerField = groupBy(matchesForDay, "field");
        let matchesWithTime = [];
        for (let fieldKey in matchesPerField) {
          if (
            fieldKey !== "null" &&
            (this.props.tournament.fields || {})[fieldKey]
          ) {
            let field = this.props.tournament.fields[fieldKey];
            let startTimestamp = field.startTime;
            // if (
            //   (!this.state.manualDaySelected
            //     ? initialDay
            //     : this.state.selectedDay) !== "0"
            // ) {
            //   startTimestamp =
            //     field[
            //       !this.state.manualDaySelected
            //         ? initialDay
            //         : this.state.selectedDay
            //     ] || field.startTime;
            // }
            if (d !== "0") {
              startTimestamp = field[d] || field.startTime;
            }
            let fieldMatches = matchesPerField[fieldKey];
            fieldMatches.sort((a, b) => {
              if (Number(a.numInField) > Number(b.numInField)) {
                return 1;
              } else if (Number(a.numInField) < Number(b.numInField)) {
                return -1;
              } else {
                return 0;
              }
            });
            for (let m in fieldMatches) {
              let match = fieldMatches[m];
              const startTime = moment.unix(startTimestamp).format("HH:mm");
              const endTime = moment
                .unix(
                  startTimestamp +
                    getMatchDuration(
                      this.props.tournament,
                      this.state.poulesByKey,
                      match
                    ) *
                      60
                )
                .format("HH:mm");
              if (match.isBreak) {
                startTimestamp += Number(match.duration || 0) * 60;
                if (match.isEvent) {
                  match["startTime"] = startTime;
                  match["endTime"] = endTime;
                }
              } else {
                startTimestamp +=
                  getMatchDuration(
                    this.props.tournament,
                    this.state.poulesByKey,
                    match
                  ) * 60;
                startTimestamp +=
                  (this.props.tournament.timeBetweenMatches !== undefined
                    ? this.props.tournament.timeBetweenMatches
                    : defaultMatchTimes.timeBetweenMatches) * 60;
              }
              match["startTime"] = startTime;
              match["endTime"] = endTime;
              if (!match.isBreak || match.isEvent) {
                if (!match.isBreak && !match.isEvent) {
                  const poule = this.state.poulesByKey[match.poule];
                  let hideMatch = false;
                  if (poule["status" + match.team1]) {
                    hideMatch = true;
                  }
                  if (poule["status" + match.team2]) {
                    hideMatch = true;
                  }
                  if (!hideMatch) {
                    matchesWithTime.push(match);
                  }
                } else {
                  matchesWithTime.push(match);
                }
              }
            }
          }
        }
        matchesPerDay[d] = matchesWithTime;
      }

      let noMatches = true;
      Object.keys(matchesPerDay).forEach((day) => {
        let matches = matchesPerDay[day];
        if (matches.length > 0) {
          noMatches = false;
        }
      });

      let filteredMatchesPerDay = {};
      for (let d in matchesPerDay) {
        if (matchesPerDay[d].length > 0) {
          filteredMatchesPerDay[d] = matchesPerDay[d];
        }
      }
      matchesPerDay = filteredMatchesPerDay;

      // matches per round for online tournaments
      let matchesPerPhasePerRound = {};
      let bracketsStartRound = {};
      let showOnlineMatches = false;
      if (this.props.tournament.online) {
        for (let d = 0; d < this.props.divisions.length; d++) {
          let division = this.props.divisions[d];
          for (
            let p = 0;
            p < Object.keys(division.fases || defaultFases).length;
            p++
          ) {
            if (matchesPerPhasePerRound[p.toString()] === undefined) {
              matchesPerPhasePerRound[p.toString()] = {};
            }
            let objectElements = [],
              i = 0,
              j = 0;

            let poules = this.state.poules
              .filter(
                (poule) =>
                  poule.bracket === null &&
                  poule.division === division.id &&
                  poule.fase === p
              )
              .sort((a, b) => {
                if (a.indexNum > b.indexNum) {
                  return 1;
                } else if (a.indexNum < b.indexNum) {
                  return -1;
                } else {
                  return a.num - b.num;
                }
              });
            let brackets = this.state.brackets
              .filter(
                (bracket) =>
                  bracket.division === division.id && bracket.fase === p
              )
              .sort((a, b) => {
                if (a.indexNum > b.indexNum) {
                  return 1;
                } else if (a.indexNum < b.indexNum) {
                  return -1;
                } else {
                  return a.num - b.num;
                }
              });
            while (i < poules.length && j < brackets.length) {
              if (poules[i].num <= brackets[j].num) {
                const poule = poules[i];
                objectElements.push(poule);
                i++;
              } else {
                const bracket = brackets[j];
                objectElements.push(bracket);
                j++;
              }
            }

            const structureObjects = objectElements
              .concat(poules.slice(i))
              .concat(brackets.slice(j));
            // console.log(structureObjects);
            for (let y = 0; y < structureObjects.length; y++) {
              let o = structureObjects[y];
              if (o.pouleSize) {
                // poule
                let matchesForPoule = matches
                  .filter((m) => m.poule === o.id)
                  .sort((a, b) => a.numInPoule - b.numInPoule);
                // console.log(matchesForPoule);
                for (let x = 0; x < matchesForPoule.length; x++) {
                  let match = matchesForPoule[x];
                  if (
                    matchesPerPhasePerRound[p.toString()][match.round] ===
                    undefined
                  ) {
                    matchesPerPhasePerRound[p.toString()][match.round] = [];
                  }
                  matchesPerPhasePerRound[p.toString()][match.round].push(
                    match
                  );
                  showOnlineMatches = true;
                }
              } else if (o.size) {
                // bracket
                let matchesPerBracketRoundPerRound = {};
                let rounds = [];
                let poulesForBracket = this.state.poules
                  .filter((poule) => poule.bracket === o.id)
                  .sort((a, b) => a.num - b.num);

                poulesForBracket.forEach((poule) => {
                  if (
                    matchesPerBracketRoundPerRound[poule.bracketRound] ===
                    undefined
                  ) {
                    matchesPerBracketRoundPerRound[poule.bracketRound] = {};
                  }
                  let matchesForPoule = matches.filter(
                    (m) => m.poule === poule.id
                  );
                  for (let m = 0; m < matchesForPoule.length; m++) {
                    let match = matchesForPoule[m];

                    // for now use index 0 for all matches
                    if (
                      matchesPerBracketRoundPerRound[poule.bracketRound][0] ===
                      undefined
                    ) {
                      matchesPerBracketRoundPerRound[poule.bracketRound][0] =
                        [];
                    }
                    matchesPerBracketRoundPerRound[poule.bracketRound][0].push(
                      match
                    );
                  }
                });
                Object.keys(matchesPerBracketRoundPerRound)
                  .sort((a, b) => b - a)
                  .forEach((bracketRound) => {
                    let bracketRounds =
                      matchesPerBracketRoundPerRound[bracketRound];
                    Object.keys(bracketRounds).forEach((r) => {
                      let round = bracketRounds[r];
                      rounds.push(round);
                    });
                  });
                // console.log(rounds);
                let startRound = 0;
                if (o.subBracketTo) {
                  let parentBracket =
                    this.state.bracketsByKey[o.subBracketTo] || {};
                  let numRoundsToAdd = Math.log2(parentBracket.size / o.size);

                  if (
                    Object.keys(matchesPerBracketRoundPerRound[o.size] || {})
                      .length === 2
                  ) {
                    numRoundsToAdd = numRoundsToAdd * 2;
                  }
                  startRound =
                    bracketsStartRound[o.subBracketTo] + numRoundsToAdd;
                }

                // if (
                //   Object.keys(matchesPerBracketRoundPerRound[o.size] || {})
                //     .length === 2
                // ) {
                //   bracketsStartRound[o.id] = startRound;
                // } else {
                //   bracketsStartRound[o.id] = startRound;
                // }
                bracketsStartRound[o.id] = startRound;

                for (let i = 0; i < rounds.length; i++) {
                  let round = rounds[i];
                  let roundNum = i + startRound;
                  if (
                    matchesPerPhasePerRound[p.toString()][roundNum] ===
                    undefined
                  ) {
                    matchesPerPhasePerRound[p.toString()][roundNum] = [];
                  }
                  for (let x = 0; x < round.length; x++) {
                    let match = round[x];
                    matchesPerPhasePerRound[p.toString()][roundNum].push(match);
                    showOnlineMatches = true;
                  }
                }
                // console.log(matchesPerBracketRoundPerRound);
              }
            }
            // console.log(matchesPerPhasePerRound);
          }
        }
      }

      let onlineRounds = [];
      Object.keys(matchesPerPhasePerRound).forEach((p) => {
        Object.keys(matchesPerPhasePerRound[p]).forEach((r) => {
          onlineRounds.push(matchesPerPhasePerRound[p][r]);
        });
      });

      if (!this.props.tournament.online && noMatches) {
        toRender = (
          <div>
            <FasesContainer
              {...this.props}
              {...this.state}
              selectPhase={this.selectPhase}
            />
            <NoResultsMessage />
            {this.state.selectedPhase !== null && (
              <PhaseResultsDialog
                poules={this.state.poules}
                brackets={this.state.brackets}
                subBrackets={this.state.subBrackets}
                bracketsByKey={this.state.bracketsByKey}
                poulesByKey={this.state.poulesByKey}
                selectedPhase={this.state.selectedPhase}
                selectedDivision={this.state.selectedDivision}
                selectPhase={this.selectPhase}
                divisionsObject={this.props.divisionsObject}
                matches={this.state.matches}
                tournament={this.props.tournament}
                teams={this.state.teams}
                teamsByKey={this.state.teamsByKey}
                resultSpotsAll={this.state.resultSpotsAll}
              />
            )}
          </div>
        );
      } else {
        let multipleLocations = true;
        if (this.state.sportParksByKey["0"]) {
          multipleLocations = this.state.sportParks.length > 1;
        } else {
          multipleLocations = this.state.sportParks.length > 0;
        }

        toRender = (
          <div>
            <FinishedDialog
              open={this.state.finishedDialogOpen}
              handleClose={this.toggleFinishedDialog}
            />
            <div
              style={{
                overflowX: "auto",
                minWidth: 0,
                // paddingBottom: 8,
                marginBottom: 20,
              }}
            >
              <FasesContainer
                {...this.props}
                {...this.state}
                selectPhase={this.selectPhase}
              />
              <ExportContainer
                tournament={this.props.tournament}
                matches={this.state.matches}
                matchesPerDay={matchesPerDay}
                onlineRounds={onlineRounds}
                daysByKey={this.state.daysByKey}
                poules={this.state.poules}
                poulesByKey={this.state.poulesByKey}
                brackets={this.state.brackets}
                bracketsByKey={this.state.bracketsByKey}
                refereesByKey={this.state.refereesByKey}
                divisionsObject={this.props.divisionsObject}
                resultSpots={this.state.resultSpotsAll}
                sportParks={this.state.sportParks}
                sportParksByKey={this.state.sportParksByKey}
                userData={this.props.userData}
                players={this.state.players}
              />
              <RankingContainer {...this.props} {...this.state} />
            </div>
            {/* {this.state.poules.length > 0 && (
              <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={e => {
                  let poules = this.state.poules.filter(p => !p.singleMatch);
                  this.selectPoule(poules[0].id);
                }}
              >
                {languages.results.seeGroupResults}
              </Button>
            )} */}
            <div
              style={{
                paddingBottom: 15,
              }}
            >
              {!this.props.tournament.online && !noMatches ? (
                <Typography
                  variant="h6"
                  style={{ fontWeight: 500, marginBottom: 5 }}
                >
                  {languages.schedule.matches}
                </Typography>
              ) : this.props.tournament.online && showOnlineMatches ? (
                <Typography
                  variant="h6"
                  style={{ fontWeight: 500, marginBottom: 5 }}
                >
                  {languages.schedule.matches}
                </Typography>
              ) : null}
              {!this.props.tournament.online && (
                <DaysContainer
                  tournament={this.props.tournament}
                  selectedDay={
                    !this.state.manualDaySelected
                      ? initialDay
                      : this.state.selectedDay
                  }
                  selectDay={this.selectDay}
                  days={this.state.days}
                  brackets={this.state.brackets}
                  bracketsByKey={this.state.bracketsByKey}
                  daysByKey={this.state.daysByKey}
                  sportParks={this.state.sportParks}
                  sportParksByKey={this.state.sportParksByKey}
                  selectedSportPark={this.state.selectedSportPark}
                  selectSportPark={this.selectSportPark}
                  resultsPage={true}
                />
              )}
              {this.state.selectedPoule !== null && (
                <PouleResultsDialog
                  poules={this.state.poules}
                  poulesByKey={this.state.poulesByKey}
                  bracketsByKey={this.state.bracketsByKey}
                  brackets={this.state.brackets}
                  subBrackets={this.state.subBrackets}
                  selectedPoule={this.state.selectedPoule}
                  selectPoule={this.selectPoule}
                  divisionsObject={this.props.divisionsObject}
                  matches={this.state.matches}
                  tournament={this.props.tournament}
                  teams={this.state.teams}
                  teamsByKey={this.state.teamsByKey}
                  resultSpotsAll={this.state.resultSpotsAll}
                />
              )}
              {this.state.selectedPhase !== null && (
                <PhaseResultsDialog
                  poules={this.state.poules}
                  brackets={this.state.brackets}
                  subBrackets={this.state.subBrackets}
                  bracketsByKey={this.state.bracketsByKey}
                  poulesByKey={this.state.poulesByKey}
                  selectedPhase={this.state.selectedPhase}
                  selectedDivision={this.state.selectedDivision}
                  selectPhase={this.selectPhase}
                  divisionsObject={this.props.divisionsObject}
                  matches={this.state.matches}
                  tournament={this.props.tournament}
                  teams={this.state.teams}
                  teamsByKey={this.state.teamsByKey}
                  resultSpotsAll={this.state.resultSpotsAll}
                />
              )}
              <Results
                {...this.props}
                matchesPerTime={groupBy(
                  (
                    matchesPerDay[
                      !this.state.manualDaySelected
                        ? initialDay
                        : this.state.selectedDay
                    ] || []
                  ).filter((match) => {
                    let fields = this.props.tournament.fields || {};
                    let field = fields[match.field] || {};
                    let sportPark = field.sportPark || "0";

                    return (
                      sportPark === this.state.selectedSportPark &&
                      !match.isEvent
                    );
                  }),
                  "startTime"
                )}
                {...this.state}
                showReferees={showReferees}
                showReferees2={showReferees2}
                showReferees3={showReferees3}
                showReferees4={showReferees4}
                showReferees5={showReferees5}
                toggleFinishedDialog={this.toggleFinishedDialog}
                multipleLocations={multipleLocations}
                multipleDays={this.state.days.length > 0}
                players={this.state.players}
                playersByKey={this.state.playersByKey}
                manualDaySelected={this.state.manualDaySelected}
                selectDay={this.selectDay}
                selectedDay={
                  !this.state.manualDaySelected
                    ? initialDay
                    : this.state.selectedDay
                }
                selectPoule={this.selectPoule}
                // for online
                onlineRounds={onlineRounds}
                showOnlineMatches={showOnlineMatches}
              />
            </div>
          </div>
        );
      }
    }
    return this.props.tournamentAdmin === undefined ||
      this.props.tournamentAdmin.manageResults ? (
      toRender
    ) : (
      <div />
    );
  }
}

export default ResultsContainer;
